module.exports = __webpack_public_path__ + "img/59.eec44749.jpg";